import { useState } from "react";
import CloseSVG from "../../../../../icons/close";
import Button from "../../../../../button/button";
import Select from "../../../../../select/select";
import Tooltip from "../../../../../Tooltip/Tooltip";
import './PaymentMethodSubForm.scss';
import CurrencyInput from "../../../../../currencyInput/currencyInput";

const PaymentMethodSubForm = (props) => {
    const [isMethodSelected, setIsMethodSelected] = useState(false);
    const [amount, setAmount] = useState(props.method.amount || 0);
    const [currency, setCurrency] = useState(props.method.currency || 'MXN');
    const [selectedMethod, setSelectedMethod] = useState(props.method.method || '');

    const paymentMethod = [
        { value: 'EfectivoMXN', label: 'Efectivo MXN', currency: 'MXN' },
        { value: 'EfectivoUSD', label: 'Efectivo USD', currency: 'USD' },
        { value: 'Débito', label: 'Débito', currency: 'MXN' },
        { value: 'Crédito', label: 'Crédito', currency: 'MXN' },
        { value: 'Transferencia', label: 'Transferencia', currency: 'MXN' },
    ];
    const handleAmountChange = (rawValue) => {
        if (rawValue === undefined || rawValue === null || rawValue === "") {
            setAmount("");
            props.updateMethodAmount(props.index, 0, currency);
            return;
        }

        // Directamente actualizar con el valor como número
        setAmount(rawValue);
        props.updateMethodAmount(props.index, parseFloat(rawValue) || 0, currency, selectedMethod);
    };

    const handleCurrencyChange = (selectedOption) => {
        if (!selectedOption) return; // Si no hay selección, no hacer nada
        // Obtener la moneda correspondiente al método seleccionado
        const selectedCurrency = paymentMethod.find(method => method.value === selectedOption)?.currency || 'MXN';
        // Actualizar el estado local
        setCurrency(selectedCurrency);
        setSelectedMethod(selectedOption);
        setIsMethodSelected(true)

        // Pasar los valores actualizados al componente padre (SplitPay)
        props.updateMethodAmount(props.index, amount, selectedCurrency, selectedOption);
    };

    return (
        <div className="payment-method-subform">
            <div className="payment-method-actions">
                <Tooltip text="Eliminar método de pago">
                    <Button backgroundColor="transparent" onClick={() => props.removeMethodSubform(props.method.id)} Icon={CloseSVG} />
                </Tooltip>
            </div>
            <Select
                options={paymentMethod}
                placeholder={'Método de pago'}
                value={selectedMethod} // Muestra el valor correcto
                onChange={(e) => handleCurrencyChange(e.target.value)}
                classN="main-color"
            />
            <CurrencyInput
                value={amount}
                onChange={handleAmountChange}
                currencySymbol="$"
                disabled={isMethodSelected ? false : true}
                tooltip={isMethodSelected ? '' : 'Selecciona un metodo de pago'}

            />
        </div>
    );
};


export default PaymentMethodSubForm;
